module.exports = __webpack_public_path__ + "img/7502d1a.webp";